/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-this-in-sfc */
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/Tooltip";
import { useAmplitude } from "lib/amplitude/Amplitude";
import { LockIcon } from "lucide-react";
import Link from "next/link";
import type { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

interface IPremiumPaywallPopoverProps {
  isEnabled?: boolean;
  displayOrigin?: string;
  side?: "top" | "bottom" | "left" | "right";
  children: ReactElement;
}
export default function PremiumPaywallPopover({
  isEnabled,
  displayOrigin,
  side,
  children,
}: IPremiumPaywallPopoverProps) {
  const amplitude = useAmplitude();
  if (!isEnabled) {
    return children;
  }
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild={true}>{children}</TooltipTrigger>
        <TooltipContent
          side={side}
          sideOffset={12}
          asChild={true}
          className="max-w-xs rounded-3xl border border-slate-300 text-left"
        >
          <div>
            <div className="space-y-3 p-1 py-2">
              <div className="flex items-center space-x-3">
                <div className="inline-flex bg-brand p-2 text-white squircle">
                  <LockIcon strokeWidth={2} className="h-5 w-5" />
                </div>
                <div>
                  <h1 className="text-base font-bold tracking-tight">
                    <FormattedMessage defaultMessage="Só no Premium..." id="ziyMAV" />
                  </h1>
                  <p className="text-xs font-medium tracking-wide text-slate-500 dark:text-slate-400">
                    <FormattedMessage defaultMessage="Conteúdo/funcionalidade restrita" id="8nvUgj" />
                  </p>
                </div>
              </div>
              <p className="text-left font-normal tracking-wide text-slate-500 dark:text-slate-400">
                <FormattedMessage
                  defaultMessage="<a>Clique aqui</a> e junte-se ao time para ter acesso completo ao site!"
                  id="V6h8i2"
                  values={{
                    a: (text) => {
                      return (
                        <Link
                          href="/premium"
                          as="/premium"
                          passHref={true}
                          className="font-bold text-blue-600 hover:underline dark:text-blue-400"
                          prefetch={false}
                          onClick={() => {
                            amplitude.logEvent("Click on link to become Premium", {
                              origin: displayOrigin,
                            });
                          }}
                        >
                          {text}
                        </Link>
                      );
                    },
                  }}
                />
              </p>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
